"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentReimbursementExceptions = void 0;
var ShipmentReimbursementExceptions;
(function (ShipmentReimbursementExceptions) {
    ShipmentReimbursementExceptions["LOST_SHIPMENT_NOT_ELIGIBLE_FOR_REIMBURSEMENT"] = "LOST_SHIPMENT_NOT_ELIGIBLE_FOR_REIMBURSEMENT";
    ShipmentReimbursementExceptions["NO_RETAIL_PRICES_FOR_DSKUS"] = "NO_RETAIL_PRICES_FOR_DSKUS";
    ShipmentReimbursementExceptions["SELLER_NOT_AUTHORIZED_FOR_REIMBURSEMENT"] = "SELLER_NOT_AUTHORIZED_FOR_REIMBURSEMENT";
    ShipmentReimbursementExceptions["SHIPMENT_ALREADY_REIMBURSED"] = "SHIPMENT_ALREADY_REIMBURSED";
    ShipmentReimbursementExceptions["SHIPMENT_DOES_NOT_EXIST"] = "SHIPMENT_DOES_NOT_EXIST";
    ShipmentReimbursementExceptions["SHIPMENT_ID_REQUIRED"] = "SHIPMENT_ID_REQUIRED";
    ShipmentReimbursementExceptions["UNABLE_TO_CREDIT_SELLER_IN_CHARGEBEE"] = "UNABLE_TO_CREDIT_SELLER_IN_CHARGEBEE";
    ShipmentReimbursementExceptions["UNABLE_TO_SAVE_REIMBURSEMENT_IN_DB"] = "UNABLE_TO_SAVE_REIMBURSEMENT_IN_DB";
})(ShipmentReimbursementExceptions = exports.ShipmentReimbursementExceptions || (exports.ShipmentReimbursementExceptions = {}));
//# sourceMappingURL=ReimbursementData.js.map